export default __webpack_public_path__ + "static/media/chris.e1dab9f0.jpg";